<template>
  <ul class="list-bullets">
    <slot />
  </ul>
</template>
<style lang="scss">
@import './ListBullets.scss';
</style>
